/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespPromoModuleSecondary_componentModule = {
    readonly messages: {
        readonly title: string | null;
        readonly items: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly linkData: {
                readonly path: string | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModulePromoItem_promotion">;
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespPromoModuleSecondary_componentModule";
};
export type HpRespPromoModuleSecondary_componentModule$data = HpRespPromoModuleSecondary_componentModule;
export type HpRespPromoModuleSecondary_componentModule$key = {
    readonly " $data"?: HpRespPromoModuleSecondary_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModuleSecondary_componentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespPromoModuleSecondary_componentModule",
  "type": "PromoModule",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userType",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "messages",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "PromoModuleMessages",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": null,
          "concreteType": "PromoItem",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cmsId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "linkData",
              "storageKey": null,
              "args": null,
              "concreteType": "LinkData",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "path",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "HpRespPromoModulePromoItem_promotion",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'b0f6a34cb76b0e707a3737437cf919bb';
export default node;
